import axios from "axios";

const host = process.env.REACT_APP_API_HOST;

const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
};

/**
 * Utility to log administrative actions to the Activity Log system.
 * @param {string} action - The type of action (e.g., DOCTOR_REPLY, USER_BLACKLIST)
 * @param {string} details - Human readable details about the action
 */
export const logActivity = async (action, details) => {
    try {
        const token = getCookie('_auth');
        if (!token) return;

        await axios.post(`${host}/admin/logs/create`, null, {
            params: { action, details },
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    } catch (error) {
        console.error("Failed to log activity:", error);
    }
};
